/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: '較大',
	['预设']: '預設',
	['较小']: '較小',
	['字级大小']: '字級大小',
	['页面正在加载中']: '頁面正在加載中',
	['这可能需要几分钟的时间，请耐心等待']: '這可能需要幾分鐘的時間，請耐心等待。',
	['您所访问的页面不存在']: '您所訪問的頁面不存在',
	['开始对话']: '開始對話',
	['充值未到帐快速通道']: '充值未到帳快速通道',
	['人工客服']: '人工客服',
	['已接听']: '已接聽',
	['结束对话']: '結束對話',
	['联络人工客服']: '聯絡人工客服',
	['重新选择智能客服']: '重新選擇智能客服',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: '感謝您使用本次服務，煩請撥冗補充填寫調查，您寶貴的意見是我們前進的動力！',
	['您觉得此次的服务品质如何？']: '您覺得此次的服務品質如何？',
	['颗星']: '顆星',
	['颗星(單數)']: '顆星',
	['不评分']: '不評分',
	['点选下方即可结束对话']: '點選下方即可結束對話',
	['请输入您的ID']: '請輸入您的ID',
	['ID不能为空']: 'ID不能為空',
	['说明文字']: '說明文字',
	['送出']: '送出',
	['系统维护中']: '系統維護中',
	['储存']: '儲存',
	['确认']: '確認',
	['取消']: '取消',
	['完成']: '完成',
	['协作']: '協作',
	['转接']: '轉接',
	['离开']: '離開',
	['请选择服务对象开始通话']: '請選擇服務對象開始通話',
	['请填写表单']: '請填寫表單',
	['本对话已经结束']: '本對話已經結束',
	['客服已逾 {{second}} 秒未回应']: '客服已逾 {{second}} 秒未回應',
	['历史对话']: '歷史對話',
	['查无资料']: '查無資料',
	['标签']: '標籤',
	['正在输入中...']: '正在輸入中...',
	['于']: '於',
	['档案容量限制']: '檔案容量限制',
	['不能为空']: '不能為空',
	['提交']: '提交',
	['满意度']: '滿意度',
	['IP未知']: 'IP未知',
	['地区未知']: '地区未知',
	['使用者环境未知']: '使用者環境未知',
	['关闭']: '關閉',
	['全萤幕截图成档案']: '全螢幕截圖成檔案',
	['Mac用户']: 'Mac用戶',
	['Windows用户']: 'Windows使用者',
	['Windows键']: 'Windows鍵',
	['全萤幕截图至剪贴簿']: '全螢幕截圖至剪貼簿',
	['截图完成后请直接于文字输入处贴上']: '截圖完成後請直接於文字輸入處貼上',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: '使用Windows內建截圖工具或者QQ軟體截圖功能，截圖完成後請直接於文字輸入處貼上',
	['截图']: '截圖',
	['档案']: '檔案',
	['下载失败']: '下載失敗',
	['请输入分类名称']: '請輸入分類名稱',
	['新增']: '新增',
	['更新']: '更新',
	['请选择一个分类']: '請選擇一個分類',
	['请输入标题']: '請輸入標題',
	['请输入内文']: '請輸入內文',
	['请上传图片']: '請上傳圖片',
	['快捷语']: '快捷語',
	['图片']: '圖片',
	['管理分类']: '管理分類',
	['新增分类']: '新增分類',
	['标题/内文']: '標題/內文',
	['分类']: '分類',
	['编辑']: '編輯',
	['删除']: '刪除',
	['平台名称']: '平台名稱',
	['显示']: '顯示',
	['编辑服务平台']: '編輯服務平台',
	['若有服务中的客户，无法关闭服务平台']: '若有服務中的客戶，無法關閉服務平台',
	['确定']: '確定',
	['人员列表']: '人員列表',
	['服务人数']: '服務人數',
	['选择转接人员']: '選擇轉接人員',
	['按此上传图片']: '按此上傳圖片',
	['确定要取消{{displayName}}协作邀请吗？']: '確定要取消{{displayName}}協作邀請嗎？',
	['确定要结束{{displayName}}的协作吗？']: '確定要結束{{displayName}}的協作嗎？',
	['等待协作中']: '等待協作中',
	['协作中']: '協作中',
	['负责人']: '負責人',
	['已选择']: '已選擇',
	['可协作人数已满']: '可協作人數已滿',
	['选择协作人员']: '選擇協作人員',
	['提示']: '提示',
	['请输入讯息']: '請輸入訊息',
	['确定已經完成？']: '確定已經完成？',
	['常用图片']: '常用圖片',
	['用户']: '使用者',
	['个人']: '個人',
	['公共']: '公共',
	['开始谈话']: '開始談話',
	['等待中']: '等待中',
	['客户已离开对话']: '客戶已離開對話',
	['正在转接给']: '正在轉接給',
	['邀请你加入协作']: '邀請你加入協作',
	['请求转接']: '請求轉接',
	['正在服务中']: '正在服務中',
	['编辑平台']: '編輯平台',
	['您的连线已中断']: '您的連線已中斷',
	['正尝试重新连线']: '正嘗試重新連線',
	['重新登入']: '重新登入',
	['请先登入']: '請先登入',
	['帐号']: '帳號',
	['帐号不能为空']: '帳號不能為空',
	['请输入帐号']: '請輸入帳號',
	['密码']: '密碼',
	['密码不能为空']: '密碼不能為空',
	['请输入密码']: '請輸入密碼',
	['登录']: '登入',
	['客服系统客服端']: '客服系統客服端',
	['平台异动，请重新整理']: '平台異動，請重新整理',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: '客服系統升級維護中，請您晚點再聯繫線上客服，謝謝。',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: '客服系統進入升級維護作業，很抱歉中斷您的對話，請您晚點再聯絡線上客服。',
	['请稍后再试']: '請稍後再試',
	['是']: '是',
	['否']: '不',
	['等于']: '等於',
	['包含']: '包含',
	['排除']: '排除',
	['大于']: '大於',
	['少于']: '少於',
	['数量区间']: '數量區間',
	['客服对话数']: '客服對話數',
	['客戶对话数']: '客戶對話數',
	['即时资讯']: '即時資訊',
	['报表分析']: '報表分析',
	['平均通话时间']: '平均通話時間',
	['回覆通话数']: '回覆通話數',
	['平均等待时间']: '平均等待時間',
	['客户满意度']: '客戶滿意度',
	['历史对话记录']: '歷史對話記錄',
	['操作日志']: '操作日誌',
	['智能客服设定']: '智能客服設定',
	['机器人设定']: '機器人設定',
	['版本管理']: '版本管理',
	['档案总览']: '檔案總覽',
	['设定']: '設定',
	['公司管理']: '公司管理',
	['维修管理']: '維修管理',
	['一般设定']: '一般設定',
	['公告管理']: '公告管理',
	['帐号管理']: '帳戶管理',
	['平台管理']: '平台管理',
	['角色管理']: '角色管理',
	['团队管理']: '團隊管理',
	['标签管理']: '標籤管理',
	['查询']: '查詢',
	['重置']: '重置',
	['今天']: '今天',
	['昨天']: '昨天',
	['过去7天']: '過去7天',
	['过去10天']: '過去10天',
	['过去一个月']: '過去一個月',
	['过去90天']: '過去90天',
	['LOGO 预览']: 'LOGO 預覽',
	['档案格式：PNG、JPG，长宽不超过']: '檔案格式：PNG、JPG，長寬不超過',
	['档案太大或格式不支援']: '檔案太大或格式不支援',
	['且档案大小不得大于']: '且檔案大小不得大於',
	['上传档案']: '上傳檔案',
	['新增IP白名单成功']: '新增IP白名單成功',
	['删除IP白名单成功']: '刪除IP白名單成功',
	['请输入欲查询的IP']: '請輸入欲查詢的IP',
	['请输入IP']: '請輸入IP',
	['备注']: '備註',
	['备注不能为空']: '備註不能為空。',
	['请输入备注']: '請輸入備註',
	['新增时间']: '新增時間',
	['操作']: '操作',
	['IP白名单']: 'IP白名單',
	['新增IP']: '新增IP',
	['新增IP白名单']: '新增IP白名單',
	['确定删除此IP?']: '確定刪除此IP?',
	['平台']: '平台',
	['团队']: '團隊',
	['全体']: '全部',
	['客服']: '客服',
	['客服系统']: '客服系統',
	['个人帐号设定']: '個人帳號設定',
	['最少6码']: '最少6碼',
	['最多20码']: '最多20碼',
	['不能有空白']: '不能有空白',
	['应至少包含1个英文和数字']: '應至少包含1個英文和數字',
	['公司名称']: '公司名稱',
	['僅能输入英文和数字']: '僅能輸入英文和數字',
	['应至少包含1个英文']: '應至少包含1個英文',
	['最少5码']: '最少5碼',
	['IP不能为空']: 'IP不能為空',
	['非IP位址']: '非IP地址',
	['最多500个字']: '最多500個字',
	['启用']: '啟用',
	['禁用']: '禁用',
	['对话量']: '對話量',
	['目前客户数']: '目前客戶數',
	['目前客服数']: '目前客服數',
	['接通对话量']: '接通對話量',
	['全部']: '全部',
	['最近一天']: '最近一天',
	['最近一周']: '最近一週',
	['最近一月']: '最近一個月',
	['新增过滤器']: '新增過濾器',
	['请输入模組名称']: '請輸入模組名稱',
	['储存过滤模組']: '儲存過濾模組',
	['读取过滤模組']: '讀取過濾模組',
	['确定要删除模組']: '確定要刪除模組',
	['分钟']: '分鐘',
	['接通时间']: '接通時間',
	['通话时间']: '通話時間',
	['请选择或输入时间']: '請選擇或輸入時間',
	['等待时间']: '等待時間',
	['对话搜寻']: '對話搜尋',
	['请输入对话']: '請輸入對話',
	['客戶 ID']: '客戶 ID',
	['请输入客戶ID']: '請輸入客戶ID',
	['对话浏览模式']: '對話瀏覽模式',
	['筆']: '筆',
	['客服本名']: '客服本名',
	['进入时间']: '進入時間',
	['客服昵称']: '客服暱稱',
	['客服系统管理端']: '客服系統管理端',
	['数量']: '數量',
	['尚未上传档案']: '尚未上傳檔案',
	['输入文字']: '輸入文字',
	['请在此输入文字']: '請在此輸入文字',
	['添加项目']: '添加項目',
	['请选择']: '請選擇',
	['新增文字']: '新增文字',
	['新增档案']: '新增檔案',
	['選項']: '選項',
	['勾选标题']: '勾選標題',
	['文字內容不能为空']: '文字內容不能為空',
	['添加']: '添加',
	['上传标题']: '上傳標題',
	['单选标题']: '單選標題',
	['输入框标题']: '輸入框標題',
	['请输入']: '請輸入',
	['输入框']: '輸入框',
	['单选']: '單選',
	['核取方块']: '核取方塊',
	['请选择一个标签']: '請選擇一個標籤',
	['确定要删除此项目和其所有子项目？']: '確定要刪除此專案和其所有子專案？',
	['答案']: '答案',
	['表单']: '表單',
	['清除此阶层设定']: '清除此階層設定',
	['请输入此阶层问题']: '請輸入此階層問題',
	['新增选项']: '新增選項',
	['新增表单']: '新增表單',
	['新增答案']: '新增答案',
	['新增充值表单']: '新增充值表單',
	['若切换种类后, 将清除原有的和其子项目资料']: '若切換種類後，將清除原有的和其子專案資料。',
	['确定要清除所有资料和其子项目资料？']: '確定要清除所有資料和其子專案資料？',
	['阶层']: '階層',
	['开场语']: '開場語',
	['开场语不能为空']: '開場語不能為空',
	['结尾感谢语']: '結尾感謝語',
	['结尾感谢语不能为空']: '結尾感謝語不能為空',
	['发布']: '發布',
	['复制']: '複製',
	['选择目的平台']: '選擇目的平台',
	['确定复制到']: '確定複製到',
	['是否要正式发布到使用环境？']: '是否要正式發布到使用環境？',
	['储存版本']: '儲存版本',
	['版本名称']: '版本名稱',
	['请输入版本名称']: '請輸入版本名稱',
	['确定是否储存此版本']: '確定是否儲存此版本',
	['版本储存成功']: '版本儲存成功',
	['最多10个字']: '最多10個字',
	['公告一']: '公告一',
	['公告二']: '公告二',
	['公告三']: '公告三',
	['公告储存成功']: '公告儲存成功',
	['标题']: '標題',
	['內文']: '內文',
	['修改登入密码']: '修改登入密碼',
	['修改基本资讯']: '修改基本資訊',
	['昵称']: '暱稱',
	['昵称不能为空']: '暱稱不能為空',
	['请输入昵称']: '請輸入昵稱',
	['本名']: '本名',
	['本名不能为空']: '本名不能為空',
	['请输入本名']: '請輸入本名',
	['选择图像']: '選擇圖像',
	['状态']: '狀態',
	['平台代码']: '平台代碼',
	['平台代码不能为空']: '平台代碼不能為空',
	['使用ID模式登入']: '使用ID模式登入',
	['新增平台']: '新增平台',
	['修改平台']: '修改平台',
	['确定重新产生Key/IV?']: '確定重新產生Key/IV?',
	['进入公司成功']: '進入公司成功',
	['确定禁用公司?']: '確定禁用公司?',
	['确定启用公司?']: '確定啟用公司？',
	['修改公司']: '修改公司',
	['进入公司']: '進入公司',
	['确定进入公司?']: '確定進入公司?',
	['新增标签']: '新增標籤',
	['代号']: '代號',
	['代号不可为空']: '代號不可為空',
	['名称']: '名稱',
	['名称不可为空']: '名稱不可為空',
	['颜色']: '顏色',
	['颜色不可为空']: '顏色不可為空',
	['进入标签']: '進入標籤',
	['修改标签']: '修改標籤',
	['确定开启进入标签?']: '確定開啟進入標籤?',
	['确定关闭进入标签?']: '確定關閉進入標籤?',
	['确定删除此标签?']: '確定刪除此標籤?',
	['标签创建成功']: '標籤創建成功',
	['标签更新成功']: '標籤更新成功',
	['进入标签更新成功']: '進入標籤更新成功',
	['标签删除成功']: '標籤刪除成功',
	['请输入代号、名称等关键字']: '請輸入代號、名稱等關鍵字',
	['设定开场白成功']: '設定開場白成功',
	['客戶进入开场白']: '客戶進入開場白',
	['客戶进入开场白不可为空']: '客戶進入開場白不可為空',
	['第一次通知时间']: '第一次通知時間',
	['第{{count}}次通知时间']: '第{{count}}次通知時間',
	['设置错误']: '設置錯誤',
	['设定等待过长通知时间成功']: '設定等待過長通知時間成功',
	['秒']: '秒',
	['对话自动断开时间']: '對話自動斷開時間',
	['未发话时间']: '未發話時間',
	['未发话提示文字']: '未發話提示文字',
	['设定对话断开成功']: '設定對話斷開成功',
	['Favicon预览']: '網站圖示預覽',
	['更换 Favicon 成功']: '更換 Favicon 成功',
	['档案格式：ICO，長寬不超過 32x32 px']: '檔案格式：ICO，長寬不超過 32x32 px',
	['更换 LOGO 成功']: '更換 LOGO 成功',
	['智能客服']: '智慧客服',
	['设定通道成功']: '設置通道成功',
	['设定提示音效成功']: '設定提示音效成功',
	['单音']: '單音',
	['循环音']: '循環音',
	['编号']: '編號',
	['资料类型']: '資料類型',
	['资料类型不可为空']: '資料類型不可為空',
	['数字']: '數字',
	['字串']: '字串',
	['布林']: '布林',
	['建立标签成功']: '建立標籤成功',
	['修改标签成功']: '修改標籤成功',
	['删除标签成功']: '刪除標籤成功',
	['更换 LOGO']: '更換 LOGO',
	['更换 Favicon']: '更換 Favicon',
	['对话断开']: '對話中斷',
	['等待过长通知时间']: '等待過長通知時間',
	['开场白']: '開場白',
	['提示音效设定']: '提示音效設定',
	['通道设定']: '通道設定',
	['自定义标签']: '自訂標籤',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: '啟用維修模式將會停止客服系統運作。確定要啟用嗎？',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: '關閉維修模式，客服系統將會繼續運作。確定要關閉嗎？',
	['状态更新成功']: '狀態更新成功',
	['通知讯息更新成功']: '通知訊息更新成功',
	['维修模式']: '維修模式',
	['通知讯息设定']: '通知訊息設定',
	['尚未连线状态']: '尚未連線狀態',
	['尚未连线状态描述']: '尚未連線狀態描述',
	['已连线状态']: '已連線狀態',
	['已连线状态描述']: '已連線狀態描述',
	['开启成功']: '啟動成功',
	['关闭成功']: '關閉成功',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: '關閉登入管理模式將會限制客戶藉由輸入ID 進入客服，確定要關閉嗎？(若沒有提供客戶Profile資料則會進入錯誤頁面)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: '啟用登入管理模式將會開放客戶藉由輸入 ID 進入客服，確定要啟用嗎？',
	['请输入帐号、昵称、角色等关键字']: '請輸入帳號、暱稱、角色等關鍵字',
	['新增角色']: '新增角色',
	['修改角色']: '修改角色',
	['角色创建成功']: '角色創建成功',
	['角色更新成功']: '角色更新成功',
	['角色删除成功']: '角色刪除成功',
	['请输入角色名称，平台，权限等关键字']: '請輸入角色名稱、平台、權限等關鍵字',
	['关键字']: '關鍵字',
	['角色名称']: '角色名稱',
	['角色名称不可为空']: '角色名稱不可為空',
	['请输入角色名称']: '請輸入角色名稱',
	['上级角色']: '上級角色',
	['上级角色不可为空']: '上層角色不可為空',
	['权限']: '權限',
	['确定删除此角色?']: '確定刪除此角色?',
	['图像不能为空']: '圖像不能為空',
	['新增团队']: '新增團隊',
	['修改团队']: '修改團隊',
	['团队创建成功']: '團隊創建成功',
	['团队修改成功']: '團隊修改成功',
	['团队删除成功']: '團隊刪除成功',
	['人数']: '人數',
	['新登入密码']: '新登入密碼',
	['新密码不能设定與舊密码相同']: '新密碼不能設定與舊密碼相同',
	['新密码與確認密码不相同']: '新密碼與確認密碼不相同',
	['确定修改登入密码?']: '確定要修改登入密碼嗎？',
	['登入密码修改成功，请重新登入']: '登入密碼修改成功，請重新登入',
	['个人资讯']: '個人資訊',
	['搜寻快捷语']: '搜尋快捷語',
	['登出']: '登出',
	['帐密错误']: '帳密錯誤',
	['一']: '一',
	['二']: '二',
	['三']: '三',
	['四']: '四',
	['五']: '五',
	['六']: '六',
	['七']: '七',
	['请输入客服本名、客服昵称等关键字']: '請輸入客服本名、客服暱稱等關鍵字',
	['共 {{count}} 筆资料']: '共 {{count}} 筆資料',
	['平台语言不能为空']: '平台語言不能為空',
	['开启']: '開啟',
	['语言']: '語言',
	['切换语言']: '切換語言',
	['语言名称']: '語言名稱',
	['系统设定']: '系統設定',
	['储存成功']: '儲存成功',
	['发布成功']: '發佈成功',
	['复制成功']: '複製成功',
	['项目选取']: '專案選取',
	['图像']: '圖像',
	['角色']: '角色',
	['新增帐号']: '新增帳號',
	['角色不能为空']: '角色不能為空',
	['登入密码']: '登入密碼',
	['请输入代号、名称、备注等关键字']: '請輸入代號、名稱、備註等關鍵字',
	['确定删除此团队?']: '確定刪除此團隊?',
	['切换语言成功']: '切換語言成功',
	['确定要切换语言?']: '確定要切換語言?',
	['选项']: '選項',
	['选择语言']: '選擇語言',
	['修改成功']: '修改成功',
	['舊登入密码']: '舊登入密碼',
	['確認新登入密码']: '確認新登入密碼',
	['语言切换成功，將重整页面以套用更新']: '語言切換成功，將重整頁面以套用更新',
	['笔 / 页']: '筆 / 頁',
	['时段搜寻']: '時段搜尋',
	['请选择时段']: '請選擇時段',
	['更换背景色']: '更換背景顏色',
	['设定背景颜色成功']: '設定背景顏色成功',
	['请重新登入']: '請重新登入',
	['绑定谷歌验证']: '綁定谷歌驗證',
	['解除绑定']: '解除綁定',
	['谷歌验证状态']: '谷歌驗證狀態',
	['已绑定']: '已綁定',
	['未绑定']: '未綁定',
	['解绑谷歌验证失败']: '解綁谷歌驗證失敗',
	['二维码方式添加']: '透過二維碼添加',
	['请在 Google 身份验证器中采用添加条形码方式添加']: '請在 Google 身分驗證器中採用添加條碼方式添加',
	['密钥方式添加']: '密鑰方式添加',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: '請在 Google 驗證器中採用輸入提供的密鑰方式添加',
	['密钥如下所示']: '密鑰如下所示',
	['请再次输入登入密码']: '請再次輸入登入密碼',
	['谷歌6位动态密码']: '谷歌6位動態密碼',
	['请绑定谷歌验证']: '請綁定谷歌驗證',
	['谷歌验证绑定成功']: '谷歌驗證綁定成功',
	['解绑谷歌验证成功']: '解除綁定谷歌驗證成功',
	['确定解绑谷歌验证？']: '確定解除綁定谷歌驗證？',
	['请输入谷歌动态码']: '請輸入谷歌動態碼',
	['谷歌动态码']: '谷歌動態碼',
	['谷歌动态码不能为空']: '谷歌動態碼不能为空',
	['谷歌动态码长度6码']: '谷歌動態碼長度6碼',
	['谷歌动态码错误']: '谷歌動態碼錯誤',
	['內容']: '內容',
	['搜寻']: '搜尋',
	['连线中断，点击“确定”即重新连线客服。']: '連線中斷，點擊「確定」即重新連線客服。',
	['充值表单']: '充值表單',
	['网银充值']: '網路銀行儲值',
	['扫码充值']: '掃碼充值',
	['带入目前帐号']: '帶入目前帳號',
	['自行输入平台帐号']: '自行輸入平台帳號',
	['充值方式']: '充值方式',
	['平台帐号']: '平台帳號',
	['充值金额']: '充值金額',
	['付款人姓名']: '付款人姓名',
	['确认语']: '確認語',
	['操作时间']: '操作時間',
	['操作者']: '操作員',
	['请输入备注等关键字']: '請輸入備註等關鍵字',
	['操作类型']: '操作類型',
	['修改平台昵称']: '修改平台暱稱',
	['修改平台昵称成功']: '修改平台暱稱成功',
	['输入格式错误']: '輸入格式錯誤',
	['套用']: '套用',
	['确定套用到']: '確定套用到',
	['套用成功']: '套用成功',
	['储存方式']: '儲存方式',
	['储存時間']: '儲存時間',
	['系统发布']: '系統發布',
	['手动储存']: '手動儲存',
	['自动储存']: '自動儲存',
	['预览']: '預覽',
	['最多350个字']: '最多350個字',
	['修改']: '修改',
	['共同资讯管理']: '共同資訊管理',
	['共同资讯创建成功']: '共同資訊創建成功',
	['共同资讯修改成功']: '共同資訊修改成功',
	['新增共同资讯']: '新增共同資訊',
	['修改共同资讯']: '修改共同資訊',
	['删除成功']: '刪除成功',
	['已设置于其他答案，无法删除']: '已設置於其他答案，無法刪除',
	['请输入名称、内容等关键字']: '請輸入名稱、內容等關鍵字',
	['确定删除此共同资讯？']: '確定刪除此共同資訊？',
	['共同资讯']: '共同資訊',
	['尚未选择共同资讯']: '尚未選擇共同資訊',
	['选择共同资讯']: '選擇共同資訊',
	['选择']: '選擇',
	['点击「确定」后，即覆盖该平台的快捷语设定']: '點擊「確定」後，即覆蓋該平台的快捷語設定',
	['已复制：目的平台']: '已複製：目的平台',
	['是否离开客服系统？']: '是否離開客服系統？',
	['感谢您的作答，此次评分为：{{score}}分']: '感謝您的作答，此次評分為：{{score}}分',
	['共 {{count}} 筆']: '共 {{count}} 筆',
	['分']: '分',
	['新增公司']: '新增公司',
	['翻译']: '翻譯',
	['显示原文']: '顯示原文',
	['解绑谷歌验证']: '解除谷歌驗證',
	['请输入名称 内容等关键字']: '請輸入名稱 內容等關鍵字',
	['表单选项']: '表單選項',
	['年']: '年',
	['等待时间颜色设定']: '等待時間顏色設定',
	['显示颜色']: '顯示顏色',
	['确认删除此规则?']: '確認刪除此規則?',
	['页签']: '標籤',
	['超过 {{time}} 分钟']: '超過 {{time}} 分鐘',
	['新增成功']: '新增成功',
	['删除完成']: '刪除完成',
	['等待时间(分钟)']: '等待時間(分鐘)',
	['时间']: '時間',
	['不可为空']: '不可為空',
	['需为正整数']: '需為正整數',
	['按平台名称排列(A-Z)']: '按平台名稱排列(A-Z)',
	['按平台名称排列(Z-A)']: '按平台名稱排列(Z-A)',
	['旧版面模式']: '舊版面模式',
	['自动翻译']: '自動翻譯',
	['功能設定']: '功能設定',
	['确认切换版面？']: '確認切換版面？',
	['确认开启自动翻译？']: '確認開啟自動翻譯？',
	['确认关闭自动翻译？']: '確認關閉自動翻譯？',
	['原文']: '原文',
	['泰语']: '泰語',
	['追踪']: '追蹤',
	['取消追踪']: '取消追蹤',
	['预览影片']: '預覽影片',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: '僅能上傳 MP4、MOV、JPEG (JPG)、PNG、GIF、HEIC、RAW、HEIF檔案',
	['请勿输入语法相关字串']: '請勿輸入語法相關字串',
	['输入名称']: '輸入名稱',
	['设为预设版本']: '設為預設版本',
	['另存为新版本']: '另存為新版本',
	['请选择版本']: '請選擇版本',
	['一键开关']: '一鍵開關',
	['若有服务中的客户，无法关闭服务平台与切换版本']: '若有服務中的客戶，無法關閉服務平台與切換版本',
	['是否确认要覆盖已有的设定，储存新的设定？']: '是否確認要覆蓋已有的設定，儲存新的設定？',
	['已储存超过五个版本']: '已儲存超過五個版本',
	['版本已变动，是否需要储存？']: '版本已變更，是否需要儲存？',
	['确定删除此版本？']: '確定刪除此版本？',
	['编辑版本']: '編輯版本',
	['侦测到重复联系客服系统，若非您本人请告知客服']: '偵測到重複聯繫客服系統，若非您本人請告知客服',
	['删除此版本']: '刪除此版本',
	['刪除成功']: '刪除成功',
	['刪除失敗']: '刪除失敗',
	['儲存成功']: '儲存成功',
	['儲存失敗']: '儲存失敗',
	['您好，请问要选择哪个问题？']: '您好，請問要選擇哪個問題？',
	['等待服务区']: '等待服務區',
	['按时间排列(長到短)']: '按時間排列(長到短)',
	['按时间排列(短到長)']: '按時間排列(短到長)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: '親愛的，歡迎您的到來～很高興為您服務，請先別著急，我們即將為您提供服務 ...',
	['编辑标签']: '編輯標籤',
	['于 {{time}} 侦测到会员【稍早已离线】']: '在 {{time}} 侦测到会员【稍早已离线】',
	['{{score}}分']: '{{score}}分',
	['未评分']: '未評分',
	['客服完成']: '客服完成',
	['会员离线']: '會員離線',
	['超时自动断线']: '超時自動斷線',
	['{{text}}不可重复']: '{{text}}不可重複',
	['{{text}}不能为空']: '{{text}}不能為空',
	['{{text}}设置错误']: '{{text}}設置錯誤',
	['平均通话时长']: '平均通話時長',
	['平均通话数']: '平均通話數',
	['请选择角色名称']: '請選擇角色名稱',
	['请选择客服']: '請選擇客服',
	['请选择团队']: '請選擇團隊',
	['播放']: '播放',
	['统计时间']: '統計時間',
	['统计时间不可为空']: '統計時間不可為空',
	['请输入时间']: '請輸入時間',
	['时间筛选']: '時間篩選',
	['汇出']: '匯出',
	['未出勤']: '未出勤',
	['客服平均通话时长']: '客服平均通話時長',
	['数量筛选']: '數量篩選',
	['客服平均等待时间']: '客服平均等待時間',
	['上一个月']: '上個月',
	['导出Excel成功']: '導出Excel成功',
	['对话结束']: '對話結束',
	['满意度/客服']: '滿意度/客服',
	['日期/客服']: '日期/客服',
	['总数']: '總數',
	['日平均']: '日平均',
	['客服日均量']: '客服日均量',
	['客服通话总量']: '客服通話總量',
	['日总量']: '日總量',
	['请输入数量']: '請輸入數量',
	['满意度预设分数']: '滿意度預設分數',
	['当会员未评分，会自动给予此预设分数。']: '當會員未評分，會自動給予此預設分數。',
	['设定满意度预设分数成功']: '設定滿意度預設分數成功',
	['客户满意度管理']: '客戶滿意度管理',
	['对话结束方式']: '對話結束方式',
	['对话满意度']: '對話滿意度',
	['时段']: '時段',
	['客服平均满意度']: '客服平均滿意度',
	['公用设定']: '公用設定',
	['通话时长']: '通話時長',
	['服务时段']: '服務時段',
	['储存时间']: '儲存時間',
	['客服不可为空']: '客服不可為空',
	['团队不可为空']: '團隊不可為空',
	['请输入对话内容关键字']: '請輸入對話內容關鍵字',
	['请输入客服本名、昵称或帐号']: '請輸入客服本名、暱稱或帳號',
	['平台不可为空']: '平台不可為空',
	['线上']: '線上',
	['离线']: '離線',
	['日期不可为空']: '日期不可為空',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: '親，跟您再次確認下，申請並進行此筆充值 {{chargeNumber}} 元的帳號是 {{chargeAccount}}，對嗎？',
	['您的等待顺位为第 {{pendingOrder}} 位']: '您的等待順位為第 {{pendingOrder}} 位',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: '拒絕由 {{inviter}} 轉接至 {{invitee}}',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{name}} 已於 {{time}} 關閉視窗',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{name}} 已於 {{time}} 點選案件完成',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{name}} 已於 {{time}} 成功加入協作',
	['{{name}} 已于 {{time}} 离开协作']: '{{name}} 已於 {{time}} 離開協作',
	['{{name}} 已于 {{time}} 中断连线']: '{{name}} 已於 {{time}} 中斷連線',
	['英文']: '英文',
	['验证码设定']: '驗證碼設定',
	['启用验证码']: '啟用驗證碼',
	['设定验证码成功']: '設定驗證碼成功',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: '啟用驗證碼功能後，客戶需完成驗證才能進入客服系統等待區。',
	['禁止连续发话']: '禁止連續發話',
	['启用禁止连续发话']: '啟用禁止連續發話',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: '當會員在「限制秒數」內發話超過設定的次數，系統將會自動跳警告。',
	['客户端限制于']: '客戶端限制於',
	['发话次数达到']: '發話次數達到',
	['次']: '次',
	['暂时无法发话']: '暫時無法發話',
	['储存完成']: '儲存完成',
	['发送消息过于频繁 可稍后再试']: '發送消息過於頻繁，可稍後再試',
	['IP黑名单管理']: 'IP黑名單管理',
	['共 {{total}} 笔']: '共 {{total}} 筆',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '第 {{min}} - {{max}} 筆/共 {{total}} 筆',
	['顯示']: '顯示',
	['查询IP黑名单']: '查詢IP黑名單',
	['设定自动添加黑名单']: '設定自動添加黑名單',
	['白名單管理']: '白名單管理',
	['解除时间']: '解除時間',
	['永久封锁']: '永久封鎖',
	['新增IP黑名单']: '新增IP黑名單',
	['加入黑名单后，该IP将无法进入客服前台。']: '加入黑名單後，該IP將無法進入客服前台。',
	['请完成安全验证']: '請完成安全驗證',
	['向右滑动填充拼图']: '向右滑動填充拼圖',
	['启用功能']: '啟用功能',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: '若IP在「限制時間」內登入超過設定的「登入次數」系統即自動加入黑名單。',
	['限制时间']: '限制時間',
	['时间单位不可为空']: '時間單位不可為空',
	['时间单位']: '時間單位',
	['登入次数']: '登入次數',
	['封锁时间']: '封鎖時間',
	['锁的持续时间，时间到了会自动解除']: '鎖的持續時間，時間到了會自動解除',
	['查询IP白名单']: '查詢IP白名單',
	['删除失败']: '刪除失敗',
	['修改失败']: '修改失敗',
	['拼图验证失败次数过多']: '拼圖驗證失敗次數過多',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{name}} 已於 {{time}} 拒絕加入協作',
	['储存过滤模組成功']: '儲存過濾模組成功',
	['删除过滤模組成功']: '刪除過濾模組成功',
	['解除谷歌验证成功']: '解除谷歌驗證成功',
	['确定禁用平台?']: '確定禁用平台?',
	['确定启用平台?']: '確定啟用平台？',
	['IP管理(客户端)']: 'IP管理(客戶端)',
	['上传']: '上傳',
	['此栏位的时间会使用于报表的团队筛选']: '此欄位的時間會用於報表的團隊篩選',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: '選擇團隊：篩選出該團隊所有客服人員在團隊統計時間中的數據',
	['备注最多{{inputLimit}}个字']: '備註最多{{inputLimit}}個字',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{inviter}} 已於 {{time}} 將對話從 {{from}} 轉接給 {{invitee}}',
	['小时']: '小時',
	['日']: '日',
	['会员IP：{{ip}} 已加入前台黑名单']: '會員IP：{{ip}} 已加入前台黑名單',
	['新增失败']: '新增失敗',
	['会员IP被加入黑名单']: '會員IP被加入黑名單',
	['登入/接待时间']: '登入/接待時間',
	['timePeriodTooltipMessage']: '時間區間提示消息',
	['平均接待时间']: '平均接待時間',
	['平均登入时间']: '平均登入時間',
	['接待时间报表']: '接待時間報表',
	['登入时间报表']: '登入時間報表',
	['未登入']: '未登入',
	['设定报表']: '設定報表',
	['设定对话是否记入报表中']: '設定對話是否記入報表中',
	['平均通话时长报表']: '平均通話時長報表',
	['平均通话数报表']: '平均通話數報表',
	['平均等待时间报表']: '平均等待時間報表',
	['客户满意度报表']: '客戶滿意度報表',
	['平均回覆时间报表']: '平均回覆時間報表',
	['调整原因']: '調整原因',
	['请输入调整原因']: '請輸入調整原因',
	['调整原因不可为空']: '調整原因不可為空',
	['日期时间']: '日期時間',
	['操作人']: '操作人',
	['原因']: '原因',
	['更多']: '更多',
	['收回']: '收回',
	['设定报表成功']: '設定報表成功',
	['平均回覆时间']: '平均回覆時間',
	['客服平均回覆时间']: '客服平均回覆時間',
	['客户回头率']: '客戶回頭率',
	['客户ID']: '客戶ID',
	['客服帐号']: '客服帳號',
	['小时回头率']: '回頭率',
	['日回头率']: '日回頭率',
	['遗漏时间']: '遺漏時間',
	['请选择遗漏时间']: '請選擇遺漏時間',
	['平均遗漏时间']: '平均遺漏時間',
	['1分钟']: '1分鐘',
	['2分钟']: '2分鐘',
	['3分钟']: '3分鐘',
	['4分钟']: '4分鐘',
	['5分钟']: '5分鐘',
	['离开时间']: '離開時間',
	['客户回头率报表']: '客戶回頭率報表',
	['平台报表']: '平台報表',
	['对话总量']: '對話總量',
	['接待总量']: '接待總量',
	['遗漏总量']: '遺漏總量',
	['智能客服总量']: '智能客服總量',
	['智能转客服总量']: '智能轉客服總量',
	['最后更新时间']: '最後更新時間',
	['客服人数']: '客服人數',
	['在线客服总数']: '在線客服總數',
	['等待服务']: '等待服務',
	['正在服务']: '正在服務',
	['智能未转客服总量']: '智能未轉客服總量',
	['使用平台']: '使用平台',
	['泰文名称']: '泰文名稱',
	['请输入泰文名称']: '請輸入泰文名稱',
	['英文名称']: '英文名稱',
	['请输入英文名称']: '請輸入英文名稱',
	['中文名称']: '中文名稱',
	['请输入中文名称']: '請輸入中文名稱',
	['若无需翻译请填写中文']: '若無需翻譯請填寫中文',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: '帳號所有報表數據將連同帳號一同刪除，請問確認要刪除嗎？',
	['停用']: '停用',
	['停用帐号']: '停用帳號',
	['通话总数']: '通話總數',
	['等待中人数：{{pendingConversationCount}} 人']: '等待中人數：{{pendingConversationCount}} 人',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: '報表正在匯出中，請前往頁面「報表下載」查看進度並進行下載。',
	['汇出Load Data']: '匯出載入數據',
	['报表下载']: '報表下載',
	['全平台']: '全平台',
	['报表类型']: '報表類型',
	['数据范围']: '數據範圍',
	['汇出时间']: '匯出時間',
	['完成时间']: '完成時間',
	['申请者']: '申請者',
	['下载']: '下載',
	['重新汇出']: '重新匯出',
	['处理中']: '處理中',
	['已完成']: '已完成',
	['失败']: '失敗',
	['下载成功']: '下載成功',
	['历史对话纪录']: '歷史對話紀錄',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: '連線中斷，請點擊確定嘗試恢復連線，若無法恢復將結束對話。',
	['引用功能管理']: '引用功能管理',
	['引用对话']: '引用對話',
	['设定引用对话成功']: '設定引用對話成功',
	['客户管理']: '客戶管理',
	['重要客户帐号']: '重要客戶帳號',
	['请输入重要客户帐号、备注等关键字']: '請輸入重要客戶帳號、備註等關鍵字',
	['新增重要客户']: '新增重要客戶',
	['重要客户帐号不能为空']: '重要客戶帳號不能為空',
	['输入多个帐号请用, 区隔']: '輸入多個帳號請用, 隔開',
	['修改重要客户']: '修改重要客戶',
	['重要帐号']: '重要帳號',
	['会员类型']: '會員類型',
	['引用']: '引用',
	['收回(訊息)']: '收回(訊息)',
	['收回功能管理']: '收回功能管理',
	['收回提示文字不能为空']: '收回提示文字不能為空',
	['收回对话']: '收回對話',
	['收回提示文字（中文）']: '收回提示文字（中文）',
	['收回提示文字（英文）']: '收回提示文字（英文）',
	['收回提示文字（泰文）']: '收回提示文字（泰文）',
	['视频']: '影片',
	['确定要收回讯息吗？']: '確定要收回訊息嗎？',
	['设定收回功能成功']: '設定回收功能成功',
	['遗漏数据']: '遺漏數據',
	['全选']: '全選',
	['请选择使用平台']: '請選擇使用平台',
	['日期计算方式']: '日期計算方式',
	['以会员进入正在服务区的时间计算']: '以會員進入正在服務區的時間計算',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: '以會員進入等待服務區的時間計算，若是點擊智能客服未進入等待服務區則以點入智能客服的時間計算。',
	['以会员进入等待服务区的时间计算']: '以會員進入等待服務區的時間計算',
	['以客服接通对话的时间进行计算']: '以客服接通對話的時間進行計算',
	['以会员进入等待服务区的时间进行计算']: '以會員進入等待服務區的時間進行計算',
	['以会员点击智能客服的时间计算']: '以會員點擊智能客服的時間計算',
	['相同类型才会计算回头']: '相同類型才會計算回頭',
	['登入联系离开后再次登入联系']: '登入聯繫離開後再次登入聯繫',
	['一通对话只会触发一次回头次数']: '一通對話只會觸發一次回頭次數',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: '同一會員時間內連續聯繫3次，計算前兩通對話的客服各1次回頭',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: '每日相同會員於對話結束後{{hour}}小時內又重複聯繫的有效對話比例',
	['未登入联系离开后再次未登入联系']: '未登入聯絡離開後再次未登入聯絡',
	['请输入重要客户帐号']: '請輸入重要客戶帳號',
	['开始日期']: '開始日期',
	['结束日期']: '結束日期',
	['标签名称/数量']: '標籤名稱/數量',
	['暂无数据']: '暫無數據',
	['AI客服设定']: 'AI客服設定',
	['AI共同设定']: 'AI共同設定',
	['平台AI设定']: '平台AI設定',
	['平台 AI SKILL 设定']: '平台 AI SKILL 設定',
	['指令输入说明']: '指令輸入說明',
	['输入文字档']: '輸入文字檔',
	['不需要区分功能']: '不需要區分功能',
	['套用平台']: '套用平台',
	['请输入指令']: '請輸入指令',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'AI與會員對話超過 {0} 輪後需要通知客服人員',
	['指令']: '指令',
	['AI开关']: 'AI開關',
	['AI客服名称']: 'AI客服名稱',
	['AI客服名称不能为空']: 'AI客服名稱不能為空',
	['请输入AI客服名称']: '請輸入AI客服名稱',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: '是否要關閉AI客服？關閉後將無法再度開啟AI客服。',
	['侦测到对话有异常状态，请尽快处理']: '檢測到對話有異常狀態，請儘快處理',
	['需要转接人工客服，请尽快处理']: '需要轉接人工客服，請儘快處理',
	['总平均通话时长']: '總平均通話時長',
	['AI平均通话时长']: 'AI平均通話時長',
	['人工平均通话时长']: '人工平均通話時長',
	['每日总平均']: '每日總平均',
	['AI日平均']: 'AI日平均',
	['人工日平均']: '人工日平均',
	['通话总量']: '通話總量',
	['AI通话总量']: 'AI通話總量',
	['共同']: '共同',
	['总计']: '總計',
	['总计请勿超过{{limit}}字']: '總計請勿超過{{limit}}字',
	['总平均回覆时间']: '總平均回覆時間',
	['AI平均回覆时间']: 'AI平均回覆時間',
	['人工平均回覆时间']: '人工平均回覆時間',
	['AI日总量']: 'AI日總量',
	['人工日总量']: '人工日總量',
	['指令不能为空']: '指令不能為空',
	['{{name}} 已于 {{time}} 开启AI']: '{{name}} 已於 {{time}} 開啟AI',
	['{{name}} 已于 {{time}} 关闭AI']: '{{name}} 已於 {{time}} 關閉AI',
	['人机合作日总量']: '人機合作日總量',
	['人工通话总量']: '人工通話總量',
	['人机合作通话总量']: '人機合作通話總量',
	['以对话建立时间计算']: '以對話建立時間計算',
	['侦测到对话有异常状态 - 对话次数超过限制']: '偵測到對話有異常狀態 - 對話次數超過限制',
	['侦测到对话有异常状态 - 系统发生错误']: '偵測到對話有異常狀態 - 系統發生錯誤',
	['人机合作-人工日平均']: '人機合作-人工日平均',
	['人机合作-AI日平均']: '人機合作-AI日平均',
	['人机合作-人工平均通话时长']: '人機合作-人工平均通話時長',
	['人机合作-AI平均通话时长']: '人機合作-AI平均通話時長',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: '偵測到對話有異常狀態 - 等待AI API超過兩分鐘',
	['侦测到对话有异常状态 - AI 发生错误']: '偵測到對話有異常狀態 - AI 發生錯誤',
	['侦测到对话有异常状态 - AI 没有回复']: '偵測到對話有異常狀態 - AI 沒有回覆',
	['数据']: '數據',
	['指令不能超过{{limit}}字']: '指令不能超過{{limit}}字',
	['数据不能为空']: '數據不能為空',
	['数据不能超过100万字']: '數據不能超過100萬字',
	['需{{limit}}字以内']: '需{{limit}}字內',
	['数据输入说明']: '數據輸入說明',
	['需100万字以内']: '需100萬字以內',
	['至少要有一组 ~~~~~ 与 =====']: '至少要有一組 ~~~~~ 與 =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: '分隔符號 ~~~~~ 與 ===== 需成對出現',
	['需以 ===== 结尾']: '需以 ===== 結尾',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: '標題底下使用5個波浪號並換行，波浪號的開頭與結尾不能有其他文字或空格',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: '內容底下使用5個等號並換行，等號的開頭與結尾不能有其他文字或空格',
	['范例']: '範例',
	['标题A（可多行）']: '標題A（可多行）',
	['内容A（可多行，可含任何文字）']: '內容A（可多行，可含任何文字）',
	['标题B（可多行）']: '標題B（可多行）',
	['内容B（可多行，可含任何文字）']: '內容B（可多行，可含任何文字）',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: '模型順序（上方模型優先使用，失效時自動往下切換）',
	['主要']: '主要',
	['备援{{index}}']: '備援{{index}}',
	['新增备援模型']: '新增備援模型',
	['请输入数据']: '請輸入資料',
	['正在转接中...']: '正在轉接中...',
	['（中文）']: '（中文）',
	['（英文）']: '（英文）',
	['（泰文）']: '（泰文）',
	['（越南文）']: '（越南文）',
	['越南文名称']: '越南文名稱',
	['请输入越南文名称']: '請輸入越南文名稱',
	['模式']: '模式',
	['越南语']: '越南語',
	['IP白名单设定']: 'IP白名單設定',
	['建立时间']: '建立時間',
	['批次删除']: '批次刪除',
	['请确认是否删除 IP 白名单？']: '請確認是否刪除 IP 白名單？',
	['开启快捷选单']: '開啟快捷選單',
	['收合快捷选单']: '收合快速選單',
	['是否有收回人员讯息']: '是否有收回人員訊息',
	['是否有收回AI讯息']: '是否有收回AI訊息',
	['消息已被客服撤回']: '消息已被客服撤回',
	['用户快捷选单管理']: '用戶快捷選單管理',
	['电脑预览']: '電腦預覽',
	['手机预览']: '手機預覽',
	['档案格式：PNG、JPG、JPEG']: '檔案格式：PNG、JPG、JPEG',
	['请选择上传档案']: '請選擇上傳檔案',
	['新增快捷成功']: '新增快捷成功',
	['修改快捷成功']: '修改快捷成功',
	['设定快捷选单成功']: '設定快速選單成功',
	['删除快捷成功']: '刪除快捷成功',
	['确定删除此快捷？']: '確定刪除此快捷？',
	['新增内容']: '新增內容',
	['选项內容']: '選項內容',
	['{{itemLabel}}內容不能为空']: '{{itemLabel}}內容不能為空',
	['请输入{{itemLabel}}标题']: '請輸入{{itemLabel}}標題',
	['请输入{{itemLabel}}选项']: '請輸入{{itemLabel}}選項',
	['{{text}}不可为空']: '{{text}}不可為空',
	['显示更多']: '顯示更多',
	['公告标签']: '公告標籤',
	['请选择公告标签']: '請選擇公告標籤',
	['{{text}}标题']: '{{text}}標題',
	['{{text}}內文']: '{{text}}內文',
	['{{text}}最多{{inputLimit}}个字']: '{{text}}最多{{inputLimit}}個字',
	['公告内文档案大小总计不得大于10MB']: '公告內文檔案大小總計不得大於10MB',
	['用户尚未离开，确认要完成对话？']: '用戶尚未離開，確認要完成對話？',
	['{{name}} 已于 {{time}} 离开对话']: '{{name}} 已於 {{time}} 離開對話',
	['客服人员']: '客服人員',
	['*新增多个IP请使用逗号「 , 」隔开']: '新增多個IP請使用逗號「 , 」隔開',
	['是否新增IP白名单？']: '是否新增IP白名單？',
	['IP已存在']: 'IP已存在',
	['监控区管理']: '監控區管理',
	['监控区开关']: '監控區開關',
	['设定监控区开关成功']: '設定監控區開關成功',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: '啟用功能後，等待服務區會增加一個[監控區]頁籤，顯示全平台被AI攔截的對話與未讀時間最長的5通對話，點擊可快速跳轉至相應對話。',
	['{{name}} 新增了标签 {{tag}}']: '{{name}} 新增了標籤 {{tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{name}} 移除了標籤 {{tag}}',
	['状态切换为暂离']: '狀態切換為暫離',
	['状态切换为工作中']: '狀態切換為工作中',
	['监控区']: '監控區',
	['自动接线管理']: '自動接線管理',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: '客服全平台接待數量達到上限後，系統不會自動接入等待服務區的對話，客服人員手動接入數量不限制。',
	['自动接线数量上限']: '自動接線數量上限',
	['设定自动接线成功']: '設定自動接線成功',
	['{{name}} 进线']: '{{name}} 進線',
	['工作/暂离时间']: '工作/暫離時間',
	['工作时长报表']: '工作時長報表',
	['暂离时长报表']: '暫離時長報表',
	['平均工作时长']: '平均工作時長',
	['平均暂离时长']: '平均暫離時長',
	['关键字提醒']: '關鍵字提醒',
	['客户发话']: '客戶發話',
	['AI发话']: 'AI發話',
	['发话来源']: '發話來源',
	['请输入发话来源、关键字']: '請輸入發話來源、關鍵字',
	['新增关键字']: '新增關鍵字',
	['修改关键字']: '修改關鍵字',
	['新增关键字成功']: '新增關鍵字成功',
	['修改关键字成功']: '修改關鍵字成功',
	['删除关键字成功']: '刪除關鍵字成功',
	['是否删除此关键字？']: '是否刪除此關鍵字？',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: '請用「；」來分隔不同關鍵字，關鍵字不得超過100個字',
	['客户触发关键字 [{{word}}] 请客服人员注意']: '客戶觸發關鍵字 [{{word}}] 請客服人員注意',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI觸發關鍵字 [{{word}}] 請客服人員注意',
	['请输入通知时间']: '請輸入通知時間',
	['自动接线开关']: '自動接線開關',
	['自动接线数量上限不可为空']: '自動接線數量上限不可為空',
	['请输入数量上限']: '請輸入數量上限',
	['离开状态侦测开关']: '離開狀態偵測開關',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: '啟動後當客服人員為平台最後一個工作狀態或仍有接待中且無協作給他人對話時，無法切換為離開狀態。',
	['离开时间通知开关']: '離開時間通知開關',
	['通知时间不可重复']: '通知時間不可重複',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: '偵測權限CS帳號離開時間，離開時間達設定時間時通知權限manager以上的帳號，以及觸發離開時間的CS帳號本人。',
	['最后暂离时间报表']: '最後暫離時間報表',
	['平均最后暂离时间']: '平均最後暫離時間',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{name}} 離開時間已達 [{{minute}}] 分鐘 !',
	['历史对话记录下载']: '歷史對話紀錄下載',
	['使用模式']: '使用模式',
	['标准模式']: '標準模式',
	['ID模式']: 'ID模式',
	['即进模式']: '即進模式',
	['复制即进网址']: '複製即進網址',
	['生成新网址']: '生成新網址',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: '需提供客戶Profile資料的標準模式，此模式為系統預設模式。',
	['输入ID 进入客服，可不提供客戶Profile资料。']: '輸入ID 進入客服，可不提供客戶Profile資料。',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: '透過即進網址可直接進入客服系統，無需提供資料，系統自動給予隨機訪客名稱。',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: '請再次確認是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]',
	['以下是即进网址']: '以下是即進網址',
	['复制网址']: '複製網址',
	['使用模式切换成功']: '使用模式切換成功',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: '請再次確認是否更換網址，一經更換<<redText>>',
	['当前即进网址']: '當前即進網址',
	['新即进网址']: '新即進網址',
	['复制即进网址成功']: '複製即進網址成功',
	['报表统计']: '報表統計',
	['操作時間']: '操作時間',
	['统计类型']: '統計類型',
	['请选择统计类型']: '請選擇統計類型',
	['查询参数']: '查詢參數',
	['申请时间']: '申請時間',
	['产出时间']: '產出時間',
	['申请帐号']: '申請帳號',
	['详细资料']: '詳細資料',
	['重新执行统计']: '重新執行統計',
	['执行统计']: '執行統計',
	['登入时间范围']: '登入時間範圍',
	['选择团队：筛选出该团队所有客服人员']: '選擇團隊：篩選出該團隊所有客服人員',
	['API接收日志']: 'API接收日誌',
	['新增来源']: '新增來源',
	['CS']: '遊戲系統',
	['包网']: '包網',
	['包网API']: '包網API',
	['第 {{min}} - {{max}} 笔']: '第 {{min}} - {{max}} 筆',
	['选择的日期区间需小于等于{{limit}}天']: '選擇的日期區間需小於等於{{limit}}天',
	['请选择日期时间查询条件']: '請選擇日期時間查詢條件',
	['类型']: '類型',
	['公司']: '公司',
	['请输入公司']: '請輸入公司',
	['会员帐号']: '會員帳號',
	['请输入会员帐号']: '請輸入會員帳號',
	['是否查看详细资料？']: '是否查看詳細資料？',
	['传送资料']: '傳送資料',
	['CS回覆资料']: 'CS回覆資料',
	['内容']: '內容',
	['请选择进入的公司']: '請選擇進入的公司',
	['指令数据更新纪录']: '指令數據更新紀錄',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1.排序機制：所有公司的指令將統一排序處理，確保系統高效運作。',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2.數據隔離：用戶僅能查看自己公司的更新記錄，無法查看其他公司的記錄。',
	['微调训练']: '微調訓練',
	['执行微调']: '執行微調',
	['操作帐号']: '操作帳號',
	['是否修改AI API?']: '是否修改AI API?',
	['保存设置']: '保存設定',
	['修改AI API成功']: '修改AI API成功',
	['请输入{{text}}']: '請輸入{{text}}',
	['{{text}}不能超过{{limit}}字元']: '{{text}}不能超過{{limit}}字元',
	['AI API']: 'AI API',
	['微调训练记录']: '微調訓練記錄',
	['模型名称']: '模型名稱',
	['新增文本']: '新增文本',
	['修改文本']: '修改文本',
	['请输入名称']: '請輸入名稱',
	['取消修改微调文本']: '取消修改微調文本',
	['角色不可为空']: '角色不可為空',
	['请选择角色']: '請選擇角色',
	['内容不可为空']: '內容不可為空',
	['请输入内容']: '請輸入內容',
	['系统']: '系統',
	['会员']: '會員',
	['AI']: '人工智慧',
	['请确认是否取消？']: '請確認是否取消？',
	['新增微调文本成功']: '新增微調文本成功',
	['修改微调文本成功']: '修改微調文本成功',
	['自定模型名称']: '自定義模型名稱',
	['微调确认讯息']: '微調確認訊息',
	['请确认是否执行微调训练？']: '請確認是否執行微調訓練？',
	['删除微调文本']: '刪除微調文本',
	['请确认是否刪除？']: '請確認是否刪除？',
	['刪除微调文本成功']: '刪除微調文本成功',
	['请输入模型名称']: '請輸入模型名稱',
	['执行微调成功']: '執行微調成功',
	['取消修改文本成功']: '取消修改文本成功',
	['取消新增文本成功']: '取消新增文本成功',
	['您已成功登出客服系统。']: '您已成功登出客服系統。',
	['如需重新登录，请返回包网！']: '如需重新登入，請返回包網！',
	['您已成功登出客服系统管理端。']: '您已成功登出客服系統管理端。',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: '當「平均等待時間」顯示為 0 秒時，可能的原因如下：',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '1.當日所有對話的等待時間均為 0 秒（例如因自動接線或即時應答，無需等待）。',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2.根據公式「每日總等待時間 ÷ 每日對話數量」，計算結果經四捨五入後為 0 秒。',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: '系統顯示為「未登入」時，表示該帳號在其設定的團隊時間內未產生任何對話數據。',
	['加入微调']: '加入微調',
	['启用API Key']: '啟用API金鑰',
	['微调汇入对话记录']: '微調匯入對話紀錄',
	['对话数量']: '對話數量',
	['文本最后角色需为AI或客服人员']: '文本最後角色需為AI或客服人員',
	['汇入微调文本']: '匯入微調文本',
	['檔案格式：CSV，且档案大小不得大于']: '檔案格式：CSV，且檔案大小不得大於',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: '文本最後角色需為AI或客服人員，請修改後再進行匯出或執行微調。',
	['批量加入微调']: '批量加入微調',
	['自定加入微调的名称']: '自定義加入微調的名稱',
	['微调名称']: '微調名稱',
	['请输入微调的名称']: '請輸入微調的名稱',
	['微调的名称']: '微調的名稱',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: '請確認是否批量刪除(共 {{selectedFineTuningRecordsLength}} 筆',
	['已取消']: '已取消',
	['取消微调']: '取消微調',
	['取消微调成功']: '取消微調成功',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: '取消此筆客服系統微調訓練時，需要同時取消對應的 OpenAI 後台微調訓練。只有兩者均取消後，微調訓練才會被完整移除。請確認是否要取消此客服系統微調訓練？',
	['复制快捷语成功']: '複製快捷語成功',
	['复制常用图片成功']: '複製常用圖片成功',
	['左侧']: '左側',
	['右侧']: '右側',
	['{{text}}正在服务{{total}}则对话']: '{{text}}正在服務{{total}}則對話',
	['新增跑马灯成功']: '新增跑馬燈成功',
	['修改跑马灯成功']: '修改跑馬燈成功',
	['刪除跑马灯成功']: '刪除跑馬燈成功',
	['启用跑马灯成功']: '啟用跑馬燈成功',
	['停用跑马灯成功']: '停用跑馬燈成功',
	['对象栏位']: '對象欄位',
	['显示跑马灯内容']: '顯示跑馬燈內容',
	['请确认是否启用跑马灯？']: '請確認是否啟用跑馬燈？',
	['请确认是否停用跑马灯？']: '請確認是否停用跑馬燈？',
	['请确认是否删除跑马灯？']: '請確認是否刪除跑馬燈？',
	['{{text}}最多{{inputLimit}}组']: '{{text}}最多{{inputLimit}}組',
	['数值范围']: '數值範圍',
	['数值不能为空']: '數值不可為空',
	['数值']: '數值',
	['请输入数字']: '請輸入數字',
	['输入多组文字请用, 区隔']: '輸入多組文字請用, 區隔',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: '當用戶符合對象設定名稱及欄位規則中的內容時，才會生效跑馬燈推廣。',
	['新增跑马灯']: '新增跑馬燈',
	['对象栏位不能为空']: '對象欄位不能為空',
	['请输入对象栏位']: '請輸入對象欄位',
	['栏位规则']: '欄位規則',
	['栏位规则不能为空']: '欄位規則不能為空',
	['请选择栏位规则']: '請選擇欄位規則',
	['开头图示']: '開頭圖示',
	['开头图示不能为空']: '開頭圖示不能為空',
	['请选择开头图示']: '請選擇開頭圖示',
	['跑马灯内容']: '跑馬燈內容',
	['修改跑马灯']: '修改跑馬燈',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: '變更的平台設定將同步套用至下級角色，是否確認修改？',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: '確認要刪除[個人/公共]常用圖片[{{title}}]嗎？',
	['一经确认删除无法复原。']: '一經確認刪除無法復原。',
	['客服日志']: '客服日誌',
	['请输入内容等关键字']: '請輸入內容等關鍵字',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: '確認要刪除[個人/公共]快捷語[{{title}}]：[{{content}}]嗎？',
	['没有其他进入标签被开启，故无法关闭此进入标签']: '沒有其他進入標籤被開啟，故無法關閉此進入標籤',
	['没有其他进入标签被开启，故无法删除此标签']: '沒有其他進入標籤被開啟，故無法刪除此標籤',
	['所有人']: '所有人',
	['自定义对象']: '自定義對象',
	['套用对象']: '套用對象',
	['回主画面']: '回主畫面',
	['孟加拉语']: '孟加拉語',
	['繁体中文']: '繁體中文',
	['简体中文']: '簡體中文',
	['韩语']: '韓語',
	['日语']: '日語',
	['葡萄牙语']: '葡萄牙語',
	['印地语']: '印地語',
	['俄语']: '俄語',
	['重要资讯']: '重要資訊',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: '在對話中切換語言，在某些情況下，可能導致訊息翻譯功能延遲約 10 分鐘，影響新舊訊息的讀取。確定要切換語言?',
	['暂无对话']: '暫無對話',
	['档案上传中']: '檔案上傳中',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} 已於 {{time}} 開啟自動推播',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} 已於 {{time}} 關閉自動推播',
	['商户代码']: '商戶代碼',
	['请输入商户代码']: '請輸入商戶代碼',
	['密钥']: '密鑰',
	['请输入密钥']: '請輸入密鑰',
	['共同设定']: '共同設定',
	['充值未到帐设定']: '充值未到帳設定',
	['出款未到帐设定']: '出款未到帳設定',
	['确认进行储存？']: '確認進行儲存？',
	['SKILL开关']: 'SKILL 開關',
	['请输入SKILL']: '請輸入 SKILL',
	['派单 API 参数']: '派單 API 參數',
	['请输入派单API URL']: '請輸入派單 API URL',
	['开单者username']: '開單者 username',
	['请输入开单者username']: '請輸入開單者 username',
	['频道名称']: '頻道名稱',
	['请输入频道名称']: '請輸入頻道名稱',
	['开单原因']: '開單原因',
	['请输入开单原因']: '請輸入開單原因',
	['充值订单查询 API URL']: '充值訂單查詢 API URL',
	['出款订单查询 API URL']: '出款訂單查詢 API URL',
	['同义词设定']: '同義詞設定',
	['开启BM25']: '開啟BM25',
	['同义词']: '同義詞',
	['更新时间']: '> 更新時間',
	['批次新增同义词']: '批次新增同義詞',
	['修改同义词']: '修改同義詞',
	['新增同义词']: '新增同義詞',
	['请输入同义词，使用逗号区隔不同词汇']: '請輸入同義詞，使用逗號區隔不同詞彙',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: '請以逗號區隔不同詞彙，用分號區隔不同組同義詞',
	['输入格式说明：']: '輸入格式說明：',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: '請用，區隔不同詞彙，例如：充值,儲值,入金,課金',
	['词汇与标点符号前后不要出现空白']: '詞彙與標點符號前後不要出現空白',
	['请用；或分行(enter)区隔同组同义词，例如：']: '請用；或分行(enter)區隔同組同義詞，例如：',
	['充值,储值,入金,课金']: '充值',
	['log in,登入;亲,宝贝']: '登入,親',
	['请输入同义词']: '請輸入同義詞',
	['同义词不可为空']: '同義詞不可為空',
	['同义词格式有误']: '同義詞格式有誤',
	['同义词不可有特殊字元']: '同義詞不可有特殊字元',
	['字元不可超过10000']: '字元不可超過10000',
	['需至少输入两个词汇']: '需至少輸入兩個詞彙',
	['删除同义词']: '刪除同義詞',
	['请确认是否删除同义词？']: '請確認是否刪除同義詞？',
	['新增同义词成功']: '新增同義詞成功',
	['新增同义词失败']: '新增同義詞失敗',
	['修改同义词成功']: '修改同義詞成功',
	['修改同义词失败']: '修改同義詞失敗',
	['删除同义词成功']: '刪除同義詞成功',
	['删除同义词失败']: '刪除同義詞失敗',
	['内容有重复字']: '內容有重複字',
	['新增图片，详细图片请参考公告管理']: '新增圖片，詳細圖片請參考公告管理',
	['目前只支援ChatGPT进行微调训练']: '目前只支援ChatGPT進行微調訓練',
	['AI系列']: 'AI系列',
	['AI系列不能为空']: 'AI系列不能為空',
	['启用ChatGPT']: '啟用ChatGPT',
	['启用Gemini']: '啟用Gemini',
	['AI客服']: 'AI客服',
	['ID入口']: 'ID入口',
	['IP']: 'IP',
	['USER ID']: '使用者 ID',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}}內容不可為空',
	['{{text}}仅能输入数字']: '{{text}}僅能輸入數字',
	['{{text}}最多{{limit}}个字元']: '{{text}}最多{{limit}}個字元',
	['{{text}}最多數字{{limit}}碼']: '{{text}}最多數字{{limit}}碼',
	['{{time}}分']: '{{time}}分',
	['{{time}}时']: '{{time}}時',
	['{{time}}秒']: '{{time}}秒',
	['上一则发送后等待时间']: '上一則發送後等待時間',
	['上传图片']: '上傳圖片',
	['主要API keys']: '主要API金鑰',
	['主要语言']: '主要語言',
	['事件']: '事件',
	['以查看预览效果']: '以查看預覽效果',
	['依照选择模组设定UI显示位置及功能。']: '依據選擇模組設定UI顯示位置及功能。',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: '依照選擇的風格進行調整配色（含背景、框體、配色、線條感）。',
	['修改帐号履历成功']: '修改帳號履歷成功',
	['修改翻译API成功']: '修改翻譯API成功',
	['充值帐号']: '充值帳號',
	['共 {{numOfItems}} 笔']: '共 {{numOfItems}} 筆',
	['关 闭']: '關閉',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: '關閉後，整個推播系統將停止運作，所有推播訊息會暫時無效。您隨時可以重新開啟。',
	['内容最多20字元']: '內容最多20個字元',
	['内容预览']: '內容預覽',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: '切換後，跑馬燈文字與快捷鍵可能會出現顯示不清晰或對比度不足的情況，需到後台進行重新設定。',
	['删除履历']: '刪除履歷',
	['删除帐号履历成功']: '刪除帳號履歷成功',
	['删除跑马灯']: '刪除跑馬燈',
	['加载中...']: '載入中...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: '勾選後，該帳號在聯繫客服時，帳號名稱旁會顯示',
	['即时预览']: '即時預覽',
	['取消新增微调文本']: '取消新增微調文本',
	['古典深色风格']: '古典深色風格',
	['單次']: '單次',
	['回传表单']: '回傳表單',
	['外观风格']: '外觀風格',
	['客户端视觉设定']: '客戶端視覺設定',
	['客户端视觉设定成功']: '客戶端視覺設定成功',
	['尚无资料']: '尚無資料',
	['展开']: '展開',
	['履历数量']: '履歷數量',
	['帐号履历']: '帳號履歷',
	['帐号履历管理']: '帳號履歷管理',
	['平台代码不能有空白']: '平台代碼不能有空白',
	['平台代码仅能输入英文和数字']: '平台代碼僅能輸入英文和數字',
	['平台代码最多5码']: '平台代碼最多5碼',
	['平台代码最少2码']: '平台代碼最少2碼',
	['平台语言']: '平台語言',
	['平均首次工作时间']: '平均首次工作時間',
	['建立者']: '建立者',
	['开关']: '開關',
	['快速通道']: '快速通道',
	['手动推播']: '手動推播',
	['手机版']: '手機版',
	['批量删除']: '批量刪除',
	['排序']: '排序',
	['推播功能']: '推播功能',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: '推播功能 OFF：推播功能關閉整個系統不運作，列表中的所有策略都無效。',
	['推播时间']: '推播時間',
	['推播讯息列表']: '推播訊息列表',
	['推播设定']: '推播設定',
	['操作内容']: '操作內容',
	['收起']: '收起',
	['数值/内容']: '數值/內容',
	['数值/内容不可为空']: '數值/內容不可為空',
	['数值只能输入数字、负号、小数点']: '數值只能輸入數字、負號、小數點',
	['数值小数最多6位数']: '數值小數最多6位數',
	['数值整数最多15位']: '數值整數最多15位',
	['新增履历']: '新增履歷',
	['新增帐号履历成功']: '新增帳號履歷成功',
	['新增类型']: '新增類型',
	['无工作']: '無工作',
	['时间设定需至少为 3 分钟']: '時間設定需至少為 3 分鐘',
	['是否修改翻译API?']: '是否修改翻譯API?',
	['更新成功']: '更新成功',
	['更新者']: '更新者',
	['架构模组']: '架構模組',
	['栏位名称']: '欄位名稱',
	['栏位类型']: '欄位類型',
	['栏位类型不可为空']: '欄位類型不可為空',
	['档案格式不符']: '檔案格式不符',
	['PDF文件']: 'PDF 文件',
	['模式与间隔时间']: '模式與間隔時間',
	['欢迎回来']: '歡迎回來',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: '此操作將自動翻譯其他語言，原有輸入內容將被翻譯結果覆蓋，請確認是否繼續？',
	['汇入']: '匯入',
	['汇入微调文本成功']: '匯入微調文本成功',
	['汇出微调文本成功']: '匯出微調文本成功',
	['清空翻译']: '清空翻譯',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: '所有語系內容皆填寫完成後才可確定，可使用自動翻譯補齊其餘語系',
	['标题与内容皆需填写才可自动翻译']: '標題與內容皆需填寫才可自動翻譯',
	['状态持续时间']: '狀態持續時間',
	['用户帐号']: '用戶帳號',
	['用户帐号不能为空']: '用戶帳號不能為空',
	['电脑版']: '電腦版',
	['目前无适用推播']: '目前無適用推播',
	['目前有启用中的侦测语言平台，无法关闭']: '目前有啟用中的偵測語言平台，無法關閉',
	['确定删除IP白名单？']: '確定刪除IP白名單？',
	['确定发送推播？']: '確定發送推播？',
	['确定要关闭推播功能吗？']: '確定要關閉推播功能嗎？',
	['确认删除此笔履历?']: '確認刪除此筆履歷?',
	['确认要删除推播讯息？']: '確認要刪除推播訊息？',
	['立即登入']: '立即登入',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: '第 {{min}} - {{max}} 筆/共 {{numOfItems}} 筆',
	['筛选条件']: '篩選條件',
	['类型名称']: '類型名稱',
	['系统预设模组']: '系統預設模組',
	['经典浅色风格']: '經典淺色風格',
	['翻译API']: '翻譯API',
	['聊天介面']: '聊天介面',
	['自动推播']: '自動推播',
	['自动推播功能']: '自動推播功能',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: '自動推播功能關閉：列表中的所有推播訊息雖然仍可被客服手動執行，但所有計時器功能停止運作。',
	['自定义']: '自訂',
	['自定义文案']: '自訂文案',
	['自客服接起对话后开始计算']: '自客服接起對話後開始計算',
	['该类型目前有推播讯息套用中，无法删除']: '該類型目前有推播訊息套用中，無法刪除',
	['详细说明']: '詳細說明',
	['请先选择推播类型']: '請先選擇推播類型',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: '請確認是否批量刪除(共 {{selectedFineTuningRecordsLength}} 筆)？',
	['请输入事件']: '請輸入事件',
	['请输入会员ID']: '請輸入會員ID',
	['请输入內容']: '請輸入內容',
	['请输入关键字']: '請輸入關鍵字',
	['请输入您的会员 ID 以继续']: '請輸入您的會員 ID 以繼續',
	['请输入数值/内容']: '請輸入數值/內容',
	['请输入文字']: '請輸入文字',
	['请输入栏位名称']: '請輸入欄位名稱',
	['请输入用户帐号']: '請輸入用戶帳號',
	['请输入类型名称']: '請輸入類型名稱',
	['请输入详细说明']: '請輸入詳細說明',
	['请选择上方下拉选单']: '請選擇上方下拉選單',
	['请选择主要语言自动翻译']: '請選擇主要語言自動翻譯',
	['请选择帐号状态']: '請選擇帳號狀態',
	['请选择平台']: '請選擇平台',
	['请选择推播项目']: '請選擇推播項目',
	['请选择栏位类型']: '請選擇欄位類型',
	['请选择类型']: '請選擇類型',
	['请选择类型与项目(标题)以预览内容']: '請選擇類型與項目(標題)以預覽內容',
	['请选择表单选项']: '請選擇表單選項',
	['请选择运算规则']: '請選擇運算規則',
	['请选择预览画面']: '請選擇預覽畫面',
	['跑马灯设定']: '跑馬燈設定',
	['轮播']: '輪播',
	['轮播模式']: '輪播模式',
	['轮播间隔时间']: '輪播間隔時間',
	['运算规则']: '運算規則',
	['运算规则不可为空']: '運算規則不可為空',
	['返回上一层']: '返回上一層',
	['返回上一页']: '返回上一頁',
	['送出推播']: '送出推播',
	['选单介面']: '選單介面',
	['选择推播类型']: '選擇推播類型',
	['选择推播项目(标题)']: '選擇推播項目(標題)',
	['通知时间']: '通知時間',
	['通知时间不能为空']: '通知時間不能为空',
	['重新产生Key/IV']: '重新產生Key/IV',
	['重要客户']: '重要客戶',
	['需为1~60正整数']: '需為1~60正整數',
	['预估时间']: '預估時間',
	['预览图片']: '預覽圖片',
	['首次工作时间报表']: '首次工作時間報表',
	['日志管理']: '日誌管理',
	['API传送日志']: 'API傳送日誌',
	['订单号']: '訂單號',
	['三方单号']: '三方單號',
	['请输入订单号']: '請輸入訂單號',
	['请输入三方单号']: '請輸入三方單號',
	['充值订单查询']: '充值訂單查詢',
	['出款订单查询']: '出款訂單查詢',
	['开派单']: '開派單',
	['传送派单信息']: '傳送派單訊息',
	['CS传送资料']: 'CS傳送資料',
	['平台回覆资料']: '平台回覆資料',
	['{{text}}需以{{prefix}}开头']: '{{-text}}需以{{-prefix}}開頭',
	['系统通知']: '系統通知',
	['派单传送讯息']: '派單傳送訊息',
	['派单传送档案']: '派單傳送檔案',
	['请输入平台']: '請輸入平台',
	['派单讯息润饰设定']: '派單訊息潤飾設定',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: '此指令不會載入「AI共同設定」與「平台AI設定」，為獨立的 Agent 使用',
	['用户个人设定']: '用戶個人設定',
	['新增用户个人资讯']: '新增用戶個人資訊',
	['个人资讯参数名称']: '個人資訊參數名稱',
	['请输入个人资讯参数名称']: '請輸入個人資訊參數名稱',
	['*新增多个请使用逗号「 , 」隔开']: '*新增多個請使用逗號「 , 」隔開',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: '用來設定該平台哪些個人資訊要丟給AI，只有設定在「用戶個人設定」的參數，才會傳送給AI',
	['批次删除用户个人资讯']: '批次刪除用戶個人資訊',
	['确定要批次删除用户个人资讯吗？']: '確定要批次刪除用戶個人資訊嗎？',
	['个人资讯参数名称不能为空']: '個人資訊參數名稱不能為空',
	['已存在「{{name}}」']: '已存在「{{-name}}」',
	['最多可新增{{limit}}个，已超过上限']: '最多可新增{{-limit}}個，已超過上限',
	['新增用户个人资讯成功']: '新增用戶個人資訊成功',
	['新增用户个人资讯失败']: '新增用戶個人資訊失敗',
	['删除用户个人资讯成功']: '刪除用戶個人資訊成功',
	['删除用户个人资讯失败']: '刪除用戶個人資訊失敗',
	['图像管理']: '圖像管理',
	['自定义图像']: '自定義圖像',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: '檔案格式：「PNG、JPG」檔案大小不得大於 500KB',
	['档案最大500K']: '檔案最大500K',
	['新增图像成功']: '新增圖像成功',
	['删除图像成功']: '刪除圖像成功',
	['是否确定删除图像？']: '是否確定刪除圖像？',
	['内容设定']: '內容設定',
	['英语']: '英語',
	['{{language}}内容']: '{{language}}內容',
	['请输入{{language}}内容']: '請輸入{{language}}內容',
	['请选择时间']: '請選擇時間',
	['请选择公司']: '請選擇公司',
	['请输入{{label}}']: '請輸入{{label}}',
	['原文参考（{{language}}）']: '原文參考（{{language}}）',
	['确定清空设定吗？']: '確定清空設定嗎？',
	['确定取消设定吗？']: '確定取消設定嗎？',
	['{{language}}{{tab}}']: '{{language}}{{tab}}',
	['未完成']: '未完成',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}}{{label}}超過{{limit}}字',
	['公告标题']: '公告標題',
	['进线IP']: '進線IP',
	['请输入进线IP']: '請輸入進線IP',
	['模型切换：{{fromModel}} -> {{toModel}}']: '模型切換：{{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: '包網後台刪除帳號後，客服系統帳號將同步刪除',
	['系统已有新版本，请重新整理']: '系統已有新版本，請重新整理',
	['页面加载失败，请重试']: '頁面載入失敗，請重試',
	['翻译中']: '翻譯中',
	['监控与即时摘要设定']: '監控與即時摘要設定',
	['批量转接']: '批量轉接',
	['已选 {{count}} 则对话']: '已選 {{count}} 則對話',
	['勾选']: '勾選',
	['全平台服务人数']: '全平台服務人數',
	['未开启{{platform}}平台']: '未開啟{{-platform}}平台',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: '成功由 {{-inviter}} 轉接至 {{-invitee}}，共 {{count}} 則',
	['接受']: '接受',
	['拒绝({{seconds}}S)']: '拒絕({{seconds}}S)',
	['生成链接']: '生成連結',
	['链接生成中...']: '連結生成中...',
	['复制链接']: '複製連結',
	['已复制链接']: '已複製連結',
	['档案上传失败']: '檔案上傳失敗',
	['转档失败，请重新上传']: '轉檔失敗，請重新上傳',
	['人工回复']: '人工回覆',
	['检视回复']: '檢視回覆',
	['{{time}} AI 拦截对话']: '{{time}} AI 攔截對話',
	['AI 拦截原因与人工回复']: 'AI 攔截原因與人工回覆',
	['人工回复失败']: '人工回覆失敗',
	['回复讯息']: '回覆訊息',
	['对话摘要']: '對話摘要',
	['建议回复']: '建議回覆',
	['拦截原因']: '攔截原因',
	['拦截回复']: '攔截回覆',
	['确定送出']: '確定送出',
	['生成链接失败']: '生成連結失敗',
	['连接超时，请稍后再试']: '連接超時，請稍後再試',
	['上一则']: '上一則',
	['下一则']: '下一則',
	['重新传送']: '重新傳送',
	['传送中...']: '傳送中...',
	['用户端翻译失败']: '用戶端翻譯失敗',
	['重新传送失败']: '重新傳送失敗',
	['请确认是否删除以下模型？']: '請確認是否刪除以下模型？',
	['新增模型']: '新增模型',
	['请选择AI系列']: '請選擇AI系列',
	['支援模型']: '支援模型',
	['支援模型不能为空']: '支援模型不能為空',
	['请选择支援模型']: '請選擇支援模型',
	['AI模型管理']: 'AI模型管理',
	['模型不能为空']: '模型不能為空',
	['请选择模型']: '請選擇模型',

	['对话类型']: '對話類型',
	['单纯AI讯息']: '單純AI訊息',
	['单纯人员讯息']: '單純人員訊息',
	['人员+AI讯息']: '人員+AI訊息',
	['是否经过AI拦截']: '是否經過AI攔截',
	['是否修改AI拦截建议回覆']: '是否修改AI攔截建議回覆',
	['监控API keys']: '監控API金鑰',
	['管理']: '管理',

	['启用显性快取']: '啟用顯性快取',
	['AI监控拦截总量']: 'AI監控攔截總量',
	['AI监控拦截']: 'AI監控攔截',
	['有修改建议回覆总量']: '有修改建議回覆總量',
	['触发关键字：{{keywords}}。']: '觸發關鍵字：{{-keywords}}。',

	['版面已套用，但尚未同步至帐号']: '版面已套用，但尚未同步至帳號',
	['服务器重设失败，下次开启工作区时会再同步']: '伺服器重設失敗，下次開啟工作區時會再同步',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: '瀏覽器無法儲存版面，離開前請確認帳號同步完成',

	['重设版面配置']: '重設版面配置',
	['确定要将版面配置回复为系统预设吗？']: '確定要將版面配置回復為系統預設嗎？',
	['客服支援语言']: '客服支援語言',
	['请选择支援语言']: '請選擇支援語言',
	['请选择客服支援语言']: '請選擇客服支援語言',

	['删除平台']: '刪除平台',
	['是否确定删除{{code}}平台']: '是否確定刪除{{-code}}平台',
	['删除{{code}}平台成功']: '刪除{{-code}}平台成功',
	['上传图片或PDF']: '上傳圖片或PDF',
	['当前平台维护中，如有疑问请联系管理员']: '目前平台維護中，如有疑問請聯繫管理員',
	['当前平台已禁用，如有疑问请联系管理员']: '目前平台已禁用，如有疑問請聯繫管理員',
	['收回提示文字']: '收回提示文字',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: '請輸入提示文字，例如：抱歉親 妹子發錯了更正一下喔！',
	['标签名称']: '標籤名稱',
	['预览失败']: '預覽失敗',
	['放大']: '放大',
	['缩小']: '縮小',
	['上一页']: '上一頁',
	['下一页']: '下一頁',
	['点击预览']: '點擊預覽',
};
